import React from 'react';
import { NavLink } from 'react-router';
import { useI18n } from '@shared/i18n';
import { cx } from '@shared/utils';
import HomeIcon from '@mui/icons-material/Home';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BusinessIcon from '@mui/icons-material/Business';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import styles from './MobileNavbar.module.css';

interface NavItem {
    to: string;
    label: string;
    icon: React.ReactNode;
}

const MobileNavbar: React.FC = (): React.ReactElement => {
    const { t } = useI18n();

    const navItems: NavItem[] = [
        { to: '/', label: t('navigation.overview'), icon: <HomeIcon /> },
        ...(import.meta.env.VITE_DEV_MODE === 'true'
            ? [
                  {
                      to: '/calendar',
                      label: t('navigation.calendar'),
                      icon: <CalendarMonthIcon />,
                  },
              ]
            : []),
        {
            to: '/requests',
            label: t('navigation.requests'),
            icon: <AssignmentIcon />,
        },
        {
            to: '/departments',
            label: t('navigation.departments'),
            icon: <BusinessIcon />,
        },
        {
            to: '/profile',
            label: t('navigation.profile'),
            icon: <PersonOutlineIcon />,
        },
    ];
    return (
        <nav
            className={styles.nav}
            aria-label={t('layout.mainNavigation')}
        >
            <div className={styles.navSection}>
                <div className={styles.navItems}>
                    {navItems.map((item): React.ReactElement => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end
                            className={({ isActive }): string =>
                                cx(
                                    styles.navLink,
                                    isActive && styles.navLinkActive,
                                )
                            }
                        >
                            <span className={styles.icon}>{item.icon}</span>
                            <span className={styles.label}>{item.label}</span>
                        </NavLink>
                    ))}
                </div>
            </div>
        </nav>
    );
};

export default MobileNavbar;
